export default class IssuePolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        //
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  issuepolicy
     * @return {mixed}
     */
    view(user, issuepolicy)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        //
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  issuepolicy
     * @return {mixed}
     */
    update(user, issuepolicy)
    {
        //
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  issuepolicy
     * @return {mixed}
     */
    restore(user, issuepolicy)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  issuepolicy
     * @return {mixed}
     */
    delete(user, issuepolicy)
    {
        //
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  issuepolicy
     * @return {mixed}
     */
    forceDelete(user, issuepolicy)
    {
        //
    }
}
